// Write your code here
import {Component} from 'react'
import './index.css'

class ShowHide extends Component {
  state = {showFirstName: false, showLastName: false}

  onToggleFirstName = () => {
    this.setState(prevState => ({showFirstName: !prevState.showFirstName}))
  }

  onToggleLastName = () => {
    this.setState(prevState => ({showLastName: !prevState.showLastName}))
  }

  render() {
    const {showFirstName, showLastName} = this.state

    return (
      <div className="bg-container">
        <h1 className="title">Show/Hide</h1>

        <div className="buttons-container">
          <div className="section">
            <button
              type="button"
              className="toggle-button"
              onClick={this.onToggleFirstName}
            >
              Show/Hide Firstname
            </button>

            {showFirstName ? <p className="name-card">Joe</p> : null}
          </div>

          <div className="section">
            <button
              type="button"
              className="toggle-button"
              onClick={this.onToggleLastName}
            >
              Show/Hide Lastname
            </button>

            {showLastName ? <p className="name-card">Jonas</p> : null}
          </div>
        </div>
      </div>
    )
  }
}

export default ShowHide
